'use strict'

const handler = require('./handler')

exports = module.exports = require('./ping')
exports.mount = handler.mount
exports.unmount = handler.unmount



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-ping/src/index.js
// module id = 273
// module chunks = 0